import { render, staticRenderFns } from "./LgFinderPageContaContabil.vue?vue&type=template&id=2b6ee43e"
import script from "./LgFinderPageContaContabil.vue?vue&type=script&lang=js"
export * from "./LgFinderPageContaContabil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports